module.exports = __webpack_public_path__ + "img/upmood-brand.84f89f78.svg";